import { User } from '../types/shared';

type ShowpadCodeArgs = {
    showpadCode: string;
};

export const addShowpadCode = async (codeArgs: ShowpadCodeArgs, updateUser: (user: User) => void) => {
    try {    
        const response = await fetch('/add-showpad-code', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ...codeArgs,
            }),
        });
    
        if (response.ok) {
            const res = await response.json();
            if (res.success) {
                updateUser(res.user);
                return { success: true, emailTriggered: res.emailTriggered === true };
            } else {
                return { success: false, message: res.message };
            }
        } else {
            throw new Error();
        }
    } catch (error: any) {
        console.error('addShowpadCode error:', error);

        return { success: false, message: error.message || 'unknown-error-adding-showpad-code' };
    }
};
